export const APP_TYPE_BROWSER = 'BROWSER';
export const APP_TYPE_THUMBNAILS = 'THUMBNAILS';
export const APP_TYPE_PDF = 'PDF';
export const BOUNDING_BOX_MARGIN_PAS = 0.1;
export const LOOKAT_MARGIN = 0.3;
export const ROUTE = 'reserved_maps';
export const SCREEN_CENTER_TARGET_X = 0.5;
export const SCREEN_CENTER_TARGET_Y = 0.5;
export const TICKET_SELECTION_TARGET_X = 0.5;
export const TICKET_SELECTION_TARGET_Y = 0.2;
export const TINY_SCREEN_SELECTION_TARGET_X = 0.47;
export const TINY_SCREEN_SELECTION_TARGET_Y = 0.2;
export const VIEW_MODE_PAS = 'pas';
export const VIEW_MODE_DESIGNER = 'designer';
export const VIEW_MODE_MANAGE_DASHBOARD = 'manage';
export const NARROW_BREAKPOINT = 768;
export const TINY_SCREEN_HEIGHT = 450;
export const BASE_PATH = '/packages/attendee/venue-map/';
